import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';

import { SUPPORTED_EVM_CHAINS, SupportedEvmChain } from '@drf/core';
import { ReownAppKitNetworkConfig } from '@drf/environments';

import { ReownWalletConnector } from '../connectors';
import { ReownAppKitService } from '../services';
import { REOWN_APPKIT_ACCESS, REOWN_APPKIT_NETWORKS, WALLET_CONNECTOR } from '../tokens';

export function provideWalletConnection(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: REOWN_APPKIT_ACCESS,
      useExisting: ReownAppKitService,
    },
    {
      provide: WALLET_CONNECTOR,
      useExisting: ReownWalletConnector,
    },
    {
      provide: SUPPORTED_EVM_CHAINS,
      useFactory: () => toSupportedEvmChains(inject(REOWN_APPKIT_NETWORKS)),
    },
  ]);
}

function toSupportedEvmChains(networks: readonly ReownAppKitNetworkConfig[]): SupportedEvmChain[] {
  return networks.map(network => ({
    chainId: network.chainId,
    chainIdHex: network.chainIdHex,
    name: network.name,
  }));
}
